const convertObjectToArray = function (obj) {
    return Object.entries(obj).map((e) => ({ [e[0]]: e[1] }));
};
const convertArrayToObject = function (arr) {
    let obj = {};
    for (let item of arr) {
        let key = Object.keys(item)[0];
        obj[key] = item[key];
    }
    return obj;
};
const sortByorder = function (a, b) {
    if (a.order == null || b.order == null) {
        return 0;
    }
    if (a.order > b.order) {
        return 1;
    }
    if (a.order < b.order) {
        return -1;
    }
    return 0;
};
export { sortByorder, convertArrayToObject, convertObjectToArray };
